import { Observable } from 'rxjs';

import { IDocument } from 'document/document';
import { DocumentOutput } from 'document/model/document.output';
import { FetchDocumentsQuery } from 'document/query/fetch-documents.query';

import { SaveDocumentCmd } from '../command/save-document.cmd';

export abstract class DocumentApplicationPort {
	public abstract saveDocument(cmd: SaveDocumentCmd): Promise<DocumentOutput>;

	public abstract saveDocuments(documents: DocumentOutput[]): void;

	public abstract fetchDocuments(
		ids: FetchDocumentsQuery
	): Observable<string[] | Error>;

	public abstract observeDocuments(ids: string[]): Observable<IDocument[]>;
}
